import React from 'react';

export const emailSidbar = [
    {
        id: 1,
        classname: 'icon-folder',
        title: 'All mail',
        badge: '',
        line: ''
    },
    {
        id: 2,
        classname: 'icon-new-window',
        title: 'Sent',
        badge: (69),
        line: ''
    },
    {
        id: 3,
        classname: 'icon-trash',
        title: 'TRASH',
        badge: (99),
        line: ''
    },
    {
        id: 4,
        classname: 'icon-star',
        title: 'Starred',
        badge: '',
        line: ''
    },
    {
        id: 5,
        line: <hr />
    },
    {
        id: 6,
        classname: 'icon-email',
        title: 'UNREAD',
        badge: '',
        line: ''
    },
    {
        id: 7,
        classname: 'icon-export',
        title: 'SPAM',
        badge: '',
        line: ''
    },
    {
        id: 8,
        classname: 'icon-share',
        title: 'OUTBOX',
        badge: '',
        line: ''
    },
    {
        id: 9,
        classname: 'icon-file',
        title: 'UPDATE',
        badge: '',
        line: ''
    },
    {
        id: 10,
        classname: 'icon-bell',
        title: 'ALERT',
        badge: '',
        line: ''
    },
    {
        id: 11,
        classname: 'icon-notepad',
        title: 'NOTES',
        badge: '',
        line: ''
    },
];
